import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Select, Typography } from 'antd';

const { Option } = Select;
const { Title } = Typography;

export default function MassImportSheetSelector({
  workbook,
  selectedSheetName,
  onSheetChanged,
}) {
  const sheetNames = useMemo(() => {
    if (!workbook) return [];
    const { SheetNames = [] } = workbook;
    return SheetNames;
  }, [workbook]);

  return (
    <div>
      <Title level={4}>Select Sheet</Title>
      <Select
        value={selectedSheetName}
        onChange={onSheetChanged}
        style={{ width: '100%', maxWidth: 400 }}
        placeholder="Select a sheet"
      >
        {sheetNames.map((name) => (
          <Option key={name} value={name}>
            {name}
          </Option>
        ))}
      </Select>
    </div>
  );
}

MassImportSheetSelector.propTypes = {
  workbook: PropTypes.shape({
    SheetNames: PropTypes.arrayOf(PropTypes.string),
  }),
  selectedSheetName: PropTypes.string,
  onSheetChanged: PropTypes.func.isRequired,
};

MassImportSheetSelector.defaultProps = {
  workbook: null,
  selectedSheetName: null,
};
